module.exports = __webpack_public_path__ + "static/img/xtrs.322b703.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xtrs.png
// module id = EgTY
// module chunks = 0